module.exports = __webpack_public_path__ + "media/images/riders/CHARLIE_HARRISON-db7c118436ca03bed15cf899a82a7ce8.png";